const contentCheckTimeout = 3000;

export default class TrustindexWidget {
	constructor(widget, element = null)
	{
		this.classes = [];

		if (widget) {
			let embeddedContent = TrustindexWidget.getComparableContent(widget);

			this.getWidget(widget);

			if (!widget.container) {
				return;
			}

			this.contentCheck = Promise.race([
				this.sendViewStat(embeddedContent).catch(error => console.warn('[Trustindex Widget] content check failed', error)),
				new Promise(resolve => setTimeout(resolve, contentCheckTimeout)),
			]);

			this.scheduleInit();

			let cssUrl = widget.getAttribute('data-css-url');
			if (!cssUrl && 'wp-widget' !== widget.pid) {
				cssUrl = this.getWidgetStylesheetUrl();
			}
			this.loadWidgetStylesheet(cssUrl, () => {});
		}

		if (element) {
			this.load(element);
		}

		window.tiWidgetInstances.push(this);
	}

	getWidget(widget)
	{
		widget.setAttribute('data-trustindex-widget', true);

		widget.layoutId = widget.getAttribute('data-layout-id');
		widget.layoutCategory = (widget.getAttribute('data-layout-category') || "").split(', ');
		widget.setId = widget.getAttribute('data-set-id');
		widget.pid = widget.getAttribute('data-pid') || 'wp-widget';
		widget.cssVersion = widget.getAttribute('data-css-version') || null;
		widget.language = widget.getAttribute('data-language') || 'en';
		widget.locales = {
			close: widget.getAttribute('data-close-locale') || 'Close',
		};
		widget.footerLinkDomain = widget.getAttribute('data-footer-link-domain') || null;
		widget.size = parseFloat(widget.getAttribute('data-size') || 1);
		widget.isLazyLoadDisabled = widget.hasAttribute('data-lazy-load-disabled');
		widget.isDelayLoadEnabled = Trustindex.isAttributeEnabled(widget, 'data-delay-load');

		if (widget.layoutId) {
			widget.layoutId = parseInt(widget.layoutId);
		}

		widget.container = widget.querySelector('.ti-widget-container');

		// translate press debug
		// - https://translatepress.com/docs/developers/exclude-certain-text-or-element-from-being-translated/
		widget.setAttribute('data-no-translation', true);

		this.widget = widget;

		if (widget.container) {
			this.getSubclasses();
		}
	}

	getSubclasses()
	{
		this.widget.TrustindexWidget = this;
		this.classes = [];

		if (this.widget.querySelector('.ti-reviews-container')) {
			this.widget.TrustindexReviewWidget = new TrustindexReviewWidget(this.widget);
			this.classes.push(this.widget.TrustindexReviewWidget);

			if (this.widget.getAttribute('data-column-vertical-separate')) {
				this.widget.TrustindexMasonryWidget = new TrustindexMasonryWidget(this.widget);
				this.classes.push(this.widget.TrustindexMasonryWidget);
			}

			if (Trustindex.getJsonDataElement(this.widget, 'ti-ai-summary')) {
				this.widget.TrustindexAiSummaryModule = new TrustindexAiSummaryModule(this.widget);
				this.classes.push(this.widget.TrustindexAiSummaryModule);
			}

			if (Trustindex.getJsonDataElement(this.widget, 'ti-lightbox-data') || 'popup' === this.widget.reviewTextMode) {
				this.widget.TrustindexReviewImageModule = new TrustindexReviewImageModule(this.widget);
				this.widget.TrustindexLightboxModule = new TrustindexLightboxModule(this.widget);
				this.classes.push(this.widget.TrustindexReviewImageModule);
				this.classes.push(this.widget.TrustindexLightboxModule);
			}

			if (('readmore' === this.widget.reviewTextMode || 'popup' === this.widget.reviewTextMode) && this.widget.querySelector('.ti-review-item .ti-read-more')) {
				this.widget.TrustindexReadMoreModule = new TrustindexReadMoreModule(this.widget);
				this.classes.push(this.widget.TrustindexReadMoreModule);
			}

			if (this.widget.getAttribute('data-pager-autoplay-timeout')) {
				this.widget.TrustindexSliderWidget = new TrustindexSliderWidget(this.widget);
				this.classes.push(this.widget.TrustindexSliderWidget);
			}

			if (this.widget.querySelector('.ti-load-more-reviews-button')) {
				this.widget.TrustindexLoadMoreModule = new TrustindexLoadMoreModule(this.widget);
				this.classes.push(this.widget.TrustindexLoadMoreModule);
			}

			if (this.widget.querySelector('.ti-widget-header')) {
				this.widget.TrustindexHeaderModule = new TrustindexHeaderModule(this.widget);
				this.classes.push(this.widget.TrustindexHeaderModule);
			}
		}

		if (this.widget.querySelector('a[href="#popup"], a[href="#dropdown"]')) {
			this.widget.TrustindexPopupWidget = new TrustindexPopupWidget(this.widget);
			this.classes.push(this.widget.TrustindexPopupWidget);
		}

		if (this.widget.querySelector('.ti-top-rated-title')) {
			this.widget.TrustindexTopRatedWidget = new TrustindexTopRatedWidget(this.widget);
			this.classes.push(this.widget.TrustindexTopRatedWidget);
		}

		if (-1 !== this.widget.layoutCategory.indexOf('fomo')) {
			this.widget.TrustindexFomoWidget = new TrustindexFomoWidget(this.widget);
			this.classes.push(this.widget.TrustindexFomoWidget);
		}

		this.widget.TrustindexDarkModeModule = new TrustindexDarkModeModule(this.widget);
		this.classes.push(this.widget.TrustindexDarkModeModule);

		if (
			-1 !== this.widget.layoutCategory.indexOf('floating') ||
			-1 !== this.widget.layoutCategory.indexOf('fomo') ||
			this.widget.querySelector('.disable-widget')
		) {
			this.widget.TrustindexCloseModule = new TrustindexCloseModule(this.widget);
			if (this.widget) {
				this.classes.push(this.widget.TrustindexCloseModule);
			}
		}
	}

	callSubclassesMethods()
	{
		let methodName = arguments[0];

		this.classes.forEach(c => {
			if (typeof c[methodName] === 'function') {
				c[methodName](...Array.from(arguments).slice(1));
			}
		});
	}

	getWidgetStylesheetUrl()
	{
		if (!this.widget.setId) {
			return null;
		}

		let cssUrl = Trustindex.getCDNUrl() + 'assets/widget-presetted-css/' + this.widget.layoutId + '-' + this.widget.setId + '.css';
		if (this.widget.cssVersion) {
			cssUrl = cssUrl.replace('widget-presetted-css/', 'widget-presetted-css/v'+ this.widget.cssVersion + '/');
		}

		return cssUrl;
	}

	loadWidgetStylesheet(cssUrl, callback)
	{
		if (!cssUrl) {
			return callback(true);
		}

		let stylesheet = this.getWidgetStylesheet(cssUrl);
		if (this.isWidgetStylesheetLoaded(cssUrl)) {
			return callback(true);
		}

		let comparableUrl = this.getComparableStylesheetUrl(cssUrl);
		if (typeof TrustindexWidget.pendingStylesheetCallbacks === 'undefined') {
			TrustindexWidget.pendingStylesheetCallbacks = new Map();
		}

		let pendingCallbacks = TrustindexWidget.pendingStylesheetCallbacks.get(comparableUrl);
		if (pendingCallbacks) {
			pendingCallbacks.push(callback);
			return;
		}

		TrustindexWidget.pendingStylesheetCallbacks.set(comparableUrl, [callback]);

		let isCompleted = false;
		let complete = (isLoaded) => {
			if (isCompleted) {
				return;
			}

			isCompleted = true;
			let callbacks = TrustindexWidget.pendingStylesheetCallbacks.get(comparableUrl) || [];
			TrustindexWidget.pendingStylesheetCallbacks.delete(comparableUrl);

			if (!isLoaded) {
				console.warn('[Trustindex Widget] stylesheet could not be loaded: ' + cssUrl);
			}

			callbacks.forEach(pendingCallback => pendingCallback(isLoaded));
		};

		if (stylesheet) {
			stylesheet.addEventListener('load', () => complete(true), { once: true });
			stylesheet.addEventListener('error', () => complete(false), { once: true });

			if (this.isWidgetStylesheetLoaded(cssUrl)) {
				complete(true);
			}

			return;
		}

		Trustindex.addCSS(cssUrl, () => complete(true), false, () => complete(false));
	}

	isWidgetStylesheetLoaded(cssUrl)
	{
		let comparableUrl = this.getComparableStylesheetUrl(cssUrl);

		return Array.from(document.styleSheets).some(stylesheet => {
			return stylesheet.href && this.getComparableStylesheetUrl(stylesheet.href) === comparableUrl;
		});
	}

	getWidgetStylesheet(cssUrl)
	{
		let comparableUrl = this.getComparableStylesheetUrl(cssUrl);

		return Array.from(document.querySelectorAll('link[rel~="stylesheet"][href]')).find(stylesheet => {
			return stylesheet.href && this.getComparableStylesheetUrl(stylesheet.href) === comparableUrl;
		}) || null;
	}

	getComparableStylesheetUrl(cssUrl)
	{
		try {
			let url = new URL(cssUrl, document.baseURI);
			let asset = url.searchParams.get('trustindex-asset');

			return url.origin + url.pathname + (asset ? '?' + asset : '');
		} catch (error) {
			return cssUrl.replace(/[?#].*$/, '');
		}
	}

	load(element)
	{
		// parse HTML
		let dom = (new DOMParser()).parseFromString(element.contentHtml, 'text/html');
		let widget = dom.querySelector('.ti-widget');

		// add widget to DOM
		element.replaceWith(widget);

		// load widget data
		this.getWidget(widget);

		// hide widget only debug messages left for us
		if (!Trustindex.isCrawler()) {
			Trustindex.hide(widget);
		}

		// error debug
		if (!widget.layoutId || !widget.container) {
			return widget.innerHTML = 'Layout id or container not found!';
		}

		console.log('[Trustindex Widget: '+this.widget.pid+' - '+this.widget.layoutId+'] content loaded');

		// insert other elements after widget such as <style>
		widget.insertedElements = [];
		dom.body.querySelectorAll('*').forEach(element => {
			widget.after(element);
			widget.insertedElements.push(element);
		});

		let cssUrl = element.getAttribute('data-css-url');
		if (!cssUrl && element.key !== 'wp-widget') {
			cssUrl = this.getWidgetStylesheetUrl();
		}

		let loaded = false;
		this.loadWidgetStylesheet(cssUrl, () => {
			if (loaded) {
				return;
			}

			loaded = true;
			Trustindex.show(widget);

			this.scheduleInit();
		});
	}

	static getComparableContent(widget)
	{
		let content = widget.cloneNode(true);

		content.querySelectorAll('script, noscript, [data-ti-json]').forEach(node => node.remove());

		content.querySelectorAll('[data-subcontent-target]').forEach(button => {
			content.querySelectorAll(button.getAttribute('data-subcontent-target')).forEach(target => target.textContent = '');
		});

		content.querySelectorAll('*').forEach(node => {
			Array.from(node.attributes).forEach(attribute => {
				if ('IMG' === node.tagName || 0 !== attribute.name.indexOf('data-')) {
					node.removeAttribute(attribute.name);
				}
			});
		});

		return content.innerHTML.replace(/<!--[\s\S]*?-->/g, '').replace(/\s+/g, '');
	}

	async sendViewStat(embeddedContent)
	{
		if (!this.widget.pid || 'wp-widget' === this.widget.pid || this.widget.isContentChecked) {
			return;
		}

		this.widget.isContentChecked = true;

		let html = await Trustindex.request(Trustindex.getWidgetUrl(this.widget.pid) + 'content.html');
		if (!html) {
			return;
		}

		let contentWidget = (new DOMParser()).parseFromString(html, 'text/html').querySelector('.ti-widget');
		if (contentWidget && embeddedContent === TrustindexWidget.getComparableContent(contentWidget)) {
			return;
		}

		let element = document.createElement('div');
		element.key = this.widget.pid;
		element.contentHtml = html;

		let widget = this.widget;

		window.tiWidgetInstances = window.tiWidgetInstances.filter(instance => instance !== this);
		this.destroy();

		let styleContainer = widget.nextElementSibling;
		if (styleContainer && styleContainer.matches('pre.ti-hidden-markup') && styleContainer.querySelector('style')) {
			styleContainer.remove();
		}

		widget.replaceWith(element);

		if (!contentWidget) {
			return element.innerHTML = html;
		}

		new TrustindexWidget(null, element).widget.isContentChecked = true;
	}

	scheduleInit()
	{
		if (this.widget.isLazyLoadDisabled || this.isFloatingWidget() || Trustindex.isEditorPreview()) {
			return this.initWidget();
		}

		let initOnApproachingViewport = () => Trustindex.onApproachingViewport(this.widget, () => this.initWidget());

		if (this.widget.isDelayLoadEnabled && !Trustindex.isInIframe()) {
			return Trustindex.onFirstActivity(initOnApproachingViewport);
		}

		return initOnApproachingViewport();
	}

	revealWidget()
	{
		[ 'display', 'opacity', 'height', 'overflow' ].forEach(property => this.widget.style.removeProperty(property));

		if ('' === this.widget.getAttribute('style')) {
			this.widget.removeAttribute('style');
		}
	}

	initWidget()
	{
		Trustindex.restoreRewrittenImages(this.widget);
		this.moveFloatingWidgetToBody();
		this.updateFooterLink();

		Trustindex.waitForVisibility(this.widget.container, async () => {
			// the content check can replace the whole markup, showing it before would flicker
			await this.contentCheck;

			if (!this.widget) {
				return;
			}

			this.revealWidget();

			this.format();
			this.resize(true);
			this.registerEvents();

			let event = new CustomEvent('widget-ready', {
				detail: { widget: this }
			});

			window.dispatchEvent(event);
		});
	}

	isFloatingWidget()
	{
		return -1 !== this.widget.layoutCategory.indexOf('floating')
			|| -1 !== this.widget.layoutCategory.indexOf('fomo')
			|| [17, 21, 52, 53].indexOf(this.widget.layoutId) !== -1; // layout-id for backward compatibility, we can delete it later
	}

	moveFloatingWidgetToBody()
	{
		if (!this.isFloatingWidget() || Trustindex.isAdminUrl() || Trustindex.isWordpressAdminUrl()) {
			return;
		}

		if (!document.body) {
			return setTimeout(() => this.moveFloatingWidgetToBody(), 40);
		}

		let widget = this.widget;
		document.body.appendChild(widget);

		let checks = 0;
		widget.floatBodyCheckInterval = setInterval(() => {
			if (widget.parentNode !== document.body) {
				document.body.appendChild(widget);
				clearInterval(widget.floatBodyCheckInterval);
			}

			checks++;
			if (checks > 20) {
				clearInterval(widget.floatBodyCheckInterval);
			}
		}, 100);
	}

	// change footer URL to not point to _blank if same site
	updateFooterLink()
	{
		if (!this.widget.footerLinkDomain || -1 === window.location.href.indexOf(this.widget.footerLinkDomain) || Trustindex.isTestWidgetUrl() || Trustindex.isInIframe()) {
			return;
		}

		let footerLink = this.widget.querySelector('a[href][target="_blank"]');
		if (footerLink) {
			footerLink.removeAttribute('target');
		}
	}

	format()
	{
		// logo additional styles
		this.updateLogoImages();

		// sprite image
		this.widget.querySelectorAll('.ti-profile-img-sprite').forEach(spriteImage => this.widget.TrustindexWidget.loadSpriteImage(spriteImage));

		// sprite image (company-image)
		this.widget.querySelectorAll('.ti-company-sprite-profile-image').forEach(spriteImage => this.loadSpriteImage(spriteImage));

		let fadeContainers = this.widget.querySelectorAll('.ti-fade-container');
		if (fadeContainers.length > 1) {
			fadeContainers.forEach(fadeContainer => fadeContainer.removeAttribute('style'));

			if (this.widget.fadeContainerInterval) {
				clearInterval(this.widget.fadeContainerInterval);
			}

			let actualContainerIndex = 0;
			this.widget.fadeContainerInterval = setInterval(() => {
				let oldIndex = actualContainerIndex;

				actualContainerIndex++;
				if (actualContainerIndex > fadeContainers.length - 1) {
					actualContainerIndex = 0;
				}

				fadeContainers[actualContainerIndex].style.display = 'flex';
				fadeContainers[oldIndex].style.opacity = 0;

				setTimeout(() => {
					fadeContainers[actualContainerIndex].style.opacity = 1;
					fadeContainers[oldIndex].style.display = 'none';
				}, 10);
			}, 3000);
		}

		let disclaimer = this.widget.querySelector('.ti-verified-by-row .ti-disclaimer');
		if (disclaimer && 'wp-widget' !== this.widget.pid) {
			disclaimer.innerHTML = disclaimer.innerHTML.replace(/^(.+?)[.!?]\s/, '<strong>$1.</strong> ');
		}

		this.callSubclassesMethods('format');
		this.formatInternationalNumbers();

		this.widget.querySelectorAll('.ti-footer, .ti-header').forEach(element => {
			let defaultUrl = Trustindex.getDefaultCompanyAvatarUrl();
			if (-1 !== this.widget.layoutCategory.indexOf('button') || -1 !== this.widget.layoutCategory.indexOf('fomo')) {
				defaultUrl = null;
			}

			return Trustindex.profileImageFallback(element, defaultUrl);
		});
	}

	resize(forceResize = false)
	{
		if (typeof this.widget.TrustindexReviewWidget === 'undefined') {
			return;
		}

		// widget overflow with width: 100% workaround
		this.widget.style.width = ''; // set back any changes to width on DOM
		let currentWidth = this.widget.offsetWidth; // get current width of widget
		Trustindex.hide(this.widget); // hide widget so we can compute parent's width

		let width = window.getComputedStyle(this.widget, null).getPropertyValue('width');
		let parent = this.widget;
		let parentWidth = 0;
		let parentPaddingWidth = 0;

		// calculate parent's inner width (widthout padding & margin)
		do {
			parent = parent.parentNode;

			if (!parent || 'HTML' === parent.nodeName) {
				break;
			}

			if (parent.clientWidth) {
				let computedStyle = window.getComputedStyle(parent, null);
				parentPaddingWidth = parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
				parentWidth = parent.clientWidth - parentPaddingWidth;
			}
		} while(parentWidth < 100);


		if ('100%' === width && parentWidth && currentWidth > parentWidth) {
			this.widget.style.width = parentWidth + 'px';

			Trustindex.show(this.widget);

			if (parentWidth < (parent.offsetWidth - parentPaddingWidth)) {
				this.widget.style.width = (parent.offsetWidth - parentPaddingWidth) + 'px';
			}
		} else {
			Trustindex.show(this.widget);
		}

		if (this.widget.originalColCount <= 1) {
			// call resize when needed
			this.classes.forEach(c => {
				if (typeof c.resize === 'function' && (c.callOneOriginalColumnResize || false)) {
					c.resize();
				}
			});

			return;
		}

		this.callSubclassesMethods('resize', forceResize);
		this.resizeAfter();
	}

	resizeAfter()
	{
		this.callSubclassesMethods('resizeAfter');
	}

	getPublicId()
	{
		return this.widget.pid;
	}

	getReviews()
	{
		if (typeof this.widget.TrustindexReviewWidget !== 'undefined') {
			return this.widget.TrustindexReviewWidget.getReviews();
		}

		return null;
	}

	destroy()
	{
		this.callSubclassesMethods('destroy');

		if (this.widget.floatBodyCheckInterval) {
			clearInterval(this.widget.floatBodyCheckInterval);
		}

		delete this.widget.layoutId;
		delete this.widget.container;
		delete this.widget;
	}

	registerEvents()
	{
		this.widget.addEventListener('click', event => {
			if (event.target.matches('a[href="#popup"], a[href="#dropdown"]')) {
				event.stopPropagation();
				this.callSubclassesMethods('click', event);
			}
		}, true);

		this.widget.addEventListener('click', event => {
			// write button dropdown click
			if (event.target.matches('.ti-header-write-btn-container > .ti-header-write-btn:not([href])')) {
				event.preventDefault();

				let dropdown = event.target.closest('.ti-header-write-btn-container').querySelector('.ti-write-btn-dropdown');
				if (!dropdown.classList.contains('ti-active')) {
					dropdown.classList.add('ti-active');

					// remove active class with every other click (outside or any dropdown item click)
					setTimeout(() => {
						document.addEventListener('click', () => dropdown.classList.remove('ti-active'), { once : true });
					}, 1);
				}
			}

			this.callSubclassesMethods('click', event);
		});

		this.widget.addEventListener('keydown', event => {
			if ('Enter' === event.key) {
				this.callSubclassesMethods('enter', event);
			}
		});
	}

	documentClick()
	{
		this.callSubclassesMethods('documentClick', event);
	}

	documentKeyup()
	{
		this.callSubclassesMethods('documentKeyup', event);
	}

	isOnViewport()
	{
		let bounding = this.widget.container.getBoundingClientRect();
		let width = this.widget.container.offsetWidth - 40;
		let height = this.widget.container.offsetHeight - 40;

		if (
			bounding.top >= -1 * height &&
			bounding.left >= -1 * width &&
			bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + height &&
			bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + height
		) {
			return true;
		}

		return false;
	}

	loadSpriteImage(element)
	{
		let spriteUrl = Trustindex.getWidgetUrl(this.widget.pid) + 'sprite.jpg';
		let index = 0;
		let height = 0;
		let topMargin = 0;

		// get review's data
		if (!element.classList.contains('ti-company-sprite-profile-image')) {
			let parent = element.closest('.ti-review-item');
			let style = getComputedStyle(element);

			if (!parent) {
				parent = element.closest('.ti-profile-img');
			}

			// style not parsed - call fv again after 100 ms
			if ('auto' === style.height || '0px' === style.height) {
				return setTimeout(() => this.loadSpriteImage(element), 100);
			}

			index = parent.getAttribute('data-index') ? parseInt(parent.getAttribute('data-index')) : [].indexOf.call(parent.parentNode.children, parent) - parent.parentNode.querySelectorAll('.ti-ai-summary-item').length;
			height = parseInt(style.height || '0');

			if (!height || isNaN(height)) {
				height = 40;
			}

			// add top margin because the first image is the company's profile image in the sprite
			let companyImageElement = this.widget.querySelector('.ti-company-sprite-profile-image')
			if (companyImageElement) {
				style = getComputedStyle(companyImageElement);
				topMargin = parseInt(style.height || '0');

				if (!topMargin || isNaN(topMargin)) {
					topMargin = 65;
				}
			}
		}

		let changeBackground = function () {
			element.style.background = 'url("'+ spriteUrl +'") 0 '+ (index * height * -1 - topMargin) + 'px';
		};

		if (element.getAttribute('data-webp')) {
			Trustindex.isWebpSupported(isSupported => {
				if (isSupported) {
					spriteUrl = spriteUrl.replace('.jpg', '.webp');
				}

				changeBackground();
			});
		} else {
			changeBackground();
		}
	}

	updateLogoImages()
	{
		if (typeof this.widget.TrustindexTopRatedWidget === 'undefined' || typeof this.widget.TrustindexSliderWidget !== 'undefined') {
			this.widget.querySelectorAll(`
				.ti-header-logo .ti-header-logo-img:not([data-logo-styles-added]):not([data-no-logo-styles]),
				.ti-large-logo img:not([data-logo-styles-added]):not([data-no-logo-styles]),
				.ti-small-logo img:not([data-logo-styles-added]):not([data-no-logo-styles])
			`).forEach(img => {
				let type = 'small-logo';
				if (img.matches('.ti-header-logo .ti-header-logo-img')) {
					type = 'header-logo';
				} else if (img.matches('.ti-large-logo img')) {
					type = 'large-logo';
				}

				let platform = img.getAttribute('alt');
				let styles = Trustindex.additionalLogoStyles[type][platform] || null;

				// domain platforms (like Szallashu-cz)
				let match = /\/logo-([^-\.]+)/.exec(img.src);
				if (match) {
					styles = Trustindex.additionalLogoStyles[type][platform + '-' + match[1]] || styles;
				}

				if (styles) {
					let styleString = styles.replace(/((?:height|width): \d+px)/g, '$1 !important');
					if ('small-logo' === type || 'large-logo' === type) {
						styleString = styleString.replace(/([\d.]+)px/g, (match, number) => {
							let size = parseFloat(number) * this.widget.size;
							return (Math.round(size * 10) / 10) + 'px';
						});
					}
					img.setAttribute('style', styleString);
					img.setAttribute('data-size', this.widget.size);
				}

				img.setAttribute('data-logo-styles-added', 1);
			});
		}
	}

	formatInternationalNumbers()
	{
		let selectors = [
			'.ti-header-rating-reviews',
			'.ti-footer .ti-rating-text',
			'.ti-footer strong',
			'.ti-header .ti-rating-text',
			'.ti-header .ti-text span',
			'.ti-ai-summary-item .ti-date',
			'.ti-header .nowrap strong',
			'.ti-header .ti-profile-details .ti-text',
			'.ti-popup-header .ti-rating-text',
		];

		// fomo widget
		if ([118, 119, 120].indexOf(this.widget.layoutId) !== -1) {
			selectors.push('.ti-header .ti-title-text');
			selectors.push('.ti-header .ti-subtitle-text');
		}

		let ratingNumberElements = this.widget.querySelectorAll(selectors.join(', '));
		ratingNumberElements.forEach(element => {
			if (element.hasAttribute('data-number-formatted')) {
				return;
			}

			let formatTextNodes = (node) => {
				if (node.nodeType === Node.TEXT_NODE) {
					let text = node.textContent;

					let match = text.match(/\b\d{4,}\b/);
					if (!match) return;

					let number = parseInt(match[0], 10);
					if (!number) return;

					let formatted = Intl.NumberFormat(Trustindex.getLocaleTag(this.widget.language)).format(number);

					node.textContent = text.replace(match[0], formatted);

					return;
				}

				if (node.nodeType === Node.ELEMENT_NODE) {
					if (node.hasAttribute('data-number-formatted')) {
						return;
					}

					node.childNodes.forEach(child => formatTextNodes(child));
				}
			};

			formatTextNodes(element);

			element.setAttribute('data-number-formatted', 1);
		});
	}
};
